import _ from 'lodash';
import React from 'react';
import { track } from '../../analytics/utils';
import {
  Border,
  GlossierLogo,
  Grid,
  InteractiveText,
  Margin,
  OneTrustIcon,
  Padding,
  Queue,
  Stack,
  Text,
} from '../../components';
import {
  legalLinks,
  LegalLink,
  SocialNetworkIcons,
  footerLinks,
  FooterLinkWrapper,
} from './shared';

export const FooterDesktop = (props) => {
  return (
    <>
      <footer>
        <Padding size={[4, 5]}>
          <Stack size={4}>
            <Margin size={[6, 0, 0, 0]} />
            <Grid columns={6}>
              <div>
                <Text align="left" textRole="light">
                  ABOUT GLOSSIER
                </Text>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.about.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.about.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.about.text}
                  </a>
                </FooterLinkWrapper>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.contact.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.contact.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.contact.text}
                  </a>
                </FooterLinkWrapper>
              </div>
              <div>
                <Text align="left" textRole="light">
                  HELP
                </Text>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.returns.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.returns.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.returns.text}
                  </a>
                </FooterLinkWrapper>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.help.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.help.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.help.text}
                  </a>
                </FooterLinkWrapper>
              </div>
              <div>
                <Text align="left" textRole="light">
                  MORE
                </Text>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.itg.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.itg.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.itg.text}
                  </a>
                </FooterLinkWrapper>
              </div>
            </Grid>

            <Margin size={[7, 0, 0, 0]}>
              <Border borderSize={[1, 0, 0, 0]} borderRole="white2" />
            </Margin>

            <Margin size={[4, 0, 8, 0]}>
              <Queue justifyContent="space-between">
                <Queue size={5}>
                  <GlossierLogo />
                  <Stack>
                    <Text align="left" textRole="info">
                      © {new Date().getFullYear()} Glossier Inc. All rights
                      reserved.
                    </Text>
                    <Queue size={5}>
                      {_.flow((legalLinks) =>
                        _.map(legalLinks, (legalLink, index) => {
                          const {
                            link,
                            description,
                            trackingDescription,
                            isPrivacyLink,
                          } = legalLink || {};
                          return (
                            <LegalLink
                              href={link}
                              target="_blank"
                              onClick={() => {
                                track('Footer Clicked', trackingDescription);
                              }}
                              key={index}
                            >
                              {description}
                              {isPrivacyLink && (
                                <OneTrustIcon width="30" height="30" />
                              )}
                            </LegalLink>
                          );
                        })
                      )(legalLinks)}
                    </Queue>
                  </Stack>
                </Queue>
                <Queue size={4.2}>
                  <SocialNetworkIcons />
                </Queue>
              </Queue>
            </Margin>
          </Stack>
        </Padding>
      </footer>
    </>
  );
};
